import { FC } from 'react';

const YellowDot: FC = () => {
  return (
    <>
      <div style={{ background: '#FFD307', height: 8, width: 8, borderRadius: '50%' }}></div>
    </>
  );
};

export default YellowDot;
